import { type DatasourceParameters } from '@atlaskit/linking-types';

import { DatasourceType } from '@canvas/atlassian-service/datasource';
import { DatasourceService } from '@canvas/atlassian-service/datasource';

export const DATASOURCE_DEFAULT_PAGE_SIZE = 100;

export const requiredConfluenceDatasourceColumns = ['id', 'title', 'type', 'space'];

export async function getDatasourceResponseByType(
  type: DatasourceType,
  fields: string[],
  parameters: DatasourceParameters,
  pageSize = DATASOURCE_DEFAULT_PAGE_SIZE,
  pageCursor = ''
) {
  const requestParams = {
    fields: fields,
    includeSchema: true,
    parameters,
    pageSize,
    pageCursor,
  };

  return await new DatasourceService(type).getData(requestParams);
}
